<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<nav class="navbar flex justify-content-between align-items-center">
  <figure class="hd_logo" style="cursor: pointer">
    <img
      id="HomeStepDriver"
      src="assets/images/logibids-logo.png"
      (click)="gotoHome()"
      alt="logibids-logo" />
  </figure>
  <ul class="nav_rt flex align-items-center justify-content-end">
    @if (user()) {
      <li class="nav-item dropdown mr_6" id="notificationStep">
        <a
          class="nav-link dropdown-toggle hover-hand user-icon blacktext"
          role="button">
          <figure
            class="notification_icon"
            #notificationButton
            (click)="handleNotificationClick($event, op)">
            <img [src]="assetsConst.bell" width="16px" height="20px" />
          </figure>
          @if (user() && user().notification_unread) {
            <p>{{ user().notification_unread }}</p>
          }
        </a>
      </li>
      @if (translateService) {
        <li class="nav-item mr_6 dropdown">
          <a
            class="nav-link dropdown-toggle hover-hand user-icon blacktext"
            (click)="handleLanguageClick($event, op2)"
            role="button">
            <figure
              style="
                position: relative !important;
                top: 0.4vh !important;
                width: 30px;
                height: 30px;
              ">
              <img [src]="assetsConst.globe" width="25px" height="25px" />
            </figure>
            <p>{{ selectedLang() ? selectedLang() : '' }}</p>
          </a>
        </li>
      }

      <li
        class="nav-item user_profile dropdown"
        (click)="checkVerification() === false ? getUser() : alertConfirm()"
        id="SettingsStep">
        <a
          class="nav-link dropdown-toggle user_cl hover-hand user-icon"
          (click)="checkVerification() === false ? op1.toggle($event) : null"
          role="button">
          <figure>
            <img
              [src]="user()?.photo ?? assetsConst.user"
              width="25px"
              height="25px" /><i class="fas fa-user fa-fw userImage"></i>
          </figure>
        </a>
      </li>

      @if (user() && (user().status === 2 || user().status === 5)) {
        <li class="mid_streme">
          <ul>
            <li
              id="ImmediateStep"
              class="nav-item dropdown mr_6"
              style="cursor: pointer; margin: 0"
              (click)="
                checkVerification() === false
                  ? gotoMyImmedidateEnqueires()
                  : alertConfirm()
              ">
              <a class="nav-link dropdown-toggle hover-hand user-icon clr">
                <figure class="emmidate_icon">
                  <img
                    [src]="assetsConst.countdown"
                    width="25px"
                    height="25px"
                    alt="countdown" />
                </figure>
              </a>
            </li>
            <li
              id="scheduleStep"
              class="nav-item dropdown"
              style="cursor: pointer; margin-inline: 7px"
              (click)="
                checkVerification() === false
                  ? gotoMyScheduleEnqueires()
                  : alertConfirm()
              ">
              <a class="nav-link dropdown-toggle hover-hand user-icon clr">
                <figure class="schedule_icon">
                  <img
                    [src]="assetsConst.hammer"
                    width="25px"
                    height="25px"
                    alt="hammer" />
                </figure>
              </a>
            </li>
          </ul>
        </li>
      }
    }

    <p-overlayPanel
      #op
      [style]="{
        width: '426px',
      }">
      <div class="mn_notification">
        <div class="title" style="font-weight: 600; font-size: 15px">
          <h4>{{ 'Notifications' | translate }}</h4>
        </div>
        <ngx-ui-loader
          loaderId="notificationLoader"
          [overlayColor]="'rgba(255,255,255,0.8)'"
          blur="13"
          [bgsOpacity]="0.1"
          fgsType="circle"
          fgsColor="#000000"
          [hasProgressBar]="false" />
        @if (notifications() && notifications().length > 0) {
          <div class="notification-item1">
            <ul
              class=""
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="50"
              [scrollWindow]="false"
              (scrolled)="onScrollingFinished()">
              @for (list of notifications(); track $index; let index = $index) {
                <li
                  [ngClass]="{ notifiViewd: list.viewed === true }"
                  (click)="
                    btn_routeNotification(
                      list.payload.type,
                      list.payload.enquiry_id,
                      list.id,
                      list.payload.vehicle_id,
                      list.payload.driver_id
                    )
                  ">
                  @if (!list.viewed) {
                    <div class="dot"></div>
                  } @else {
                    <div class="Withoutdot"></div>
                  }
                  <p>
                    {{ getFormattedMessage(list.message) }}
                    <span class="block">
                      <bdi>
                        {{ list.created_at | date: 'dd/MM/YYYY hh:mm:ss a' }}
                      </bdi>
                    </span>
                  </p>
                  @if (
                    list.payload.rating_count !== null &&
                    list.message_type === 'RATING_NOTIFICATION'
                  ) {
                    <div style="margin-left: 48px">
                      <logibids-stars
                        style="position: relative; top: 2px; left: 6px"
                        [readonly]="true"
                        [color]="'#efbf04'"
                        [maxStars]="5"
                        [initialStars]="list.payload.rating_count" />
                    </div>
                  }
                </li>
              }
            </ul>
          </div>
        } @else if (notifications() && notifications().length === 0) {
          <div class="noDataFound">
            <figure>
              <img
                [src]="assetsConst.noNotification"
                alt="noNotification"
                width=""
                height=""
                priority />
            </figure>
            <p>
              {{ 'noNotifications' | translate }}
            </p>
          </div>
        }
      </div>
    </p-overlayPanel>
    <p-overlayPanel
      #op1
      class="header_op"
      [style]="{
        width: '380px',
        'overflow-y': 'scroll',
        'scroll-behavior': 'smooth',
      }">
      <ul class="profile_drpdwn main_profile_wrapper">
        <div
          class="title"
          style="
            font-weight: 600;
            font-size: 20px;
            margin-top: 1px;
            text-align: left;
          ">
          <h4>{{ 'my_account' | translate }}</h4>
        </div>
        <li>
          <figure>
            <img [src]="assetsConst.sidebar1" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr" (click)="gotoMyProfile()"
            >{{ 'myProfile' | translate }}
          </a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        @if (user() && user().type !== 'DRIVER') {
          <li>
            <figure>
              <img [src]="assetsConst.Completeprofile" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="gotoComplete()"
              >{{ 'completeYourProfile' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
        @if (user() && user().type !== 'DRIVER') {
          <li>
            <figure>
              <img [src]="assetsConst.sidebar3" alt="svg" />
            </figure>
            <a
              class="dropdown-item hover-hand newClr"
              (click)="gotoMyVehicles()"
              >{{ 'myVehicles' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
          <li>
            <figure>
              <img [src]="assetsConst.sidebar4" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="gotoMyDrivers()"
              >{{ 'myDriver' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }

        <li>
          <figure>
            <img [src]="assetsConst.sidebar5" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr" (click)="gotoMyTrips()"
            >{{
              user() && user().type === 'DRIVER'
                ? ('myTrips' | translate)
                : ('Trips' | translate)
            }}
          </a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        @if (
          (user() &&
            user().type === 'DRIVER' &&
            user().driver &&
            user().driver.allow_earnings === true) ||
          (user() && user().type !== 'DRIVER')
        ) {
          <li>
            <figure>
              <img [src]="assetsConst.earnings" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="goToMyWallet()"
              >{{
                user() && user().type !== 'DRIVER'
                  ? ('Earnings' | translate)
                  : ('myEarnings' | translate)
              }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }

        @if (
          user() &&
          user().type === 'SERVICE_PROVIDER' &&
          user().service_provider &&
          user().service_provider.self === true
        ) {
          <li>
            <figure>
              <img [src]="assetsConst.heatMapHeader" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="gotToMyHome()"
              >{{ 'HeatMap' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
        @if (user() && user().type !== 'DRIVER') {
          <li>
            <figure>
              <img [src]="assetsConst.sidebar12" alt="svg" />
            </figure>
            <a
              class="dropdown-item hover-hand newClr"
              (click)="goToPaymentOption()"
              >{{ 'PaymentOption' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
        @if (user() && user().type === 'DRIVER') {
          <li>
            <figure>
              <img [src]="assetsConst.driverRating" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="gotoMyRating()"
              >{{ 'ratingMy' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>

          <li>
            <figure>
              <img [src]="assetsConst.contactSP" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="routeChat()"
              >{{ 'contactSP' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
        @if (
          user() &&
          (user().type === 'DRIVER' ||
            (user().type === 'SERVICE_PROVIDER' &&
              user().service_provider !== null &&
              user().service_provider.self === true))
        ) {
          <li>
            <figure>
              <img [src]="assetsConst.schedule" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="mySchedule()"
              >{{ 'mySchedule' | translate }}
            </a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
          <!-- Active toggle moved to the floating DriverActiveToggleComponent
          <li>
            <figure>
              <img [src]="assetsConst.sidebar9" alt="svg" />
            </figure>
            <a
              class="dropdown-item hover-hand header-switch newClr"
              style="display: flex; justify-content: space-between; gap: 20px">
              {{ checked ? ('active' | translate) : ('inactive' | translate) }}

              <p-inputSwitch
                [(ngModel)]="checked"
                class="float-right height-0"
                (onChange)="toggleStatus($event)">
              </p-inputSwitch>
            </a>
          </li>
          -->
        }
        @if (user() && user().type !== 'DRIVER') {
          <li>
            <figure>
              <img [src]="assetsConst.sidebar6" alt="svg" />
            </figure>
            <a
              class="dropdown-item hover-hand header-switch newClr"
              style="display: flex; justify-content: space-between; gap: 20px">
              {{ 'directDeliveryDrivers' | translate }}
              <p-inputSwitch
                [(ngModel)]="is_reqto_driver"
                class="float-right height-0"
                (onChange)="toggleDriverStatus($event)"></p-inputSwitch>
            </a>
          </li>

          <li>
            <figure>
              <img [src]="assetsConst.directBid" alt="svg" />
            </figure>
            <a
              class="dropdown-item hover-hand header-switch newClr"
              style="display: flex; justify-content: space-between; gap: 20px">
              {{ 'directbid' | translate }}
              <p-inputSwitch
                [(ngModel)]="schedule_direct_driver"
                class="float-right height-0"
                (onChange)="toggleDriverBidStatus($event)"></p-inputSwitch>
            </a>
          </li>
        }
        <li>
          <figure>
            <img [src]="assetsConst.sidebar10" alt="svg" />
          </figure>
          <a
            class="dropdown-item hover-hand header-switch newClr"
            style="display: flex; justify-content: space-between; gap: 20px">
            {{ 'Notifications' | translate }}
            <p-inputSwitch
              [(ngModel)]="notification"
              class="float-right height-0"
              (onChange)="notificationOnOff($event)"></p-inputSwitch>
          </a>
        </li>
        <ngx-ui-loader
          loaderId="uniqueLoader2"
          style="margin-bottom: -11px"
          [overlayColor]="'rgba(255,255,255,0.8)'"
          blur="13"
          [bgsOpacity]="0.1"
          fgsType="circle"
          fgsColor="#000000"
          [hasProgressBar]="false" />
        <li>
          <figure>
            <img [src]="assetsConst.sidebar7" alt="svg" />
          </figure>
          <a
            class="dropdown-item hover-hand newClr"
            (click)="gotoChangePassword()"
            >{{ 'changePass' | translate }}</a
          >
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li (click)="deleteUser()">
          <figure>
            <img [src]="assetsConst.accountControl" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr">{{
            'accountControl' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      </ul>
      <ul class="profile_drpdwn main_profile_wrapper">
        <div
          class="title"
          style="
            font-weight: 600;
            font-size: 20px;
            margin-top: 1px;
            text-align: left;
          ">
          <h4>{{ 'logibids' | translate }}</h4>
        </div>

        <li (click)="gotoAboutUs()">
          <figure>
            <img [src]="assetsConst.Vector1" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'aboutUs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>

        <li (click)="gotoTerms()">
          <figure>
            <img [src]="assetsConst.Vector2" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'termsConditions' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li (click)="gotoPrivacy()">
          <figure>
            <img [src]="assetsConst.Vector3" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'privacyPolicy' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        @if (user() && user().type !== 'DRIVER') {
          <li (click)="gotoContract()">
            <figure>
              <img [src]="assetsConst.Vector4" alt="svg" />
            </figure>
            @if (user() && user().type !== 'DRIVER') {
              <a class="dropdown-item hover-hand newClr fnt">{{
                'legalContract' | translate
              }}</a>
              <div class="arrow">
                <figure>
                  <img [src]="assetsConst.headerArrow" alt="dsfds" />
                </figure>
              </div>
            }
          </li>
        }
        <li (click)="gotoContact()">
          <figure>
            <img [src]="assetsConst.contactCall" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'contactUs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li (click)="gotoFaq()">
          <figure>
            <img [src]="assetsConst.Faqs" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'Faqs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li (click)="gotoHelpGuide()">
          <figure>
            <img [src]="assetsConst.HelpGuide" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'HelpGuide' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li (click)="openAI()">
          <figure>
            <img [src]="assetsConst.chatSupport" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'chatSupport' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      </ul>

      <ul class="profile_drpdwn main_profile_wrapper">
        <div
          class="title"
          style="
            font-weight: 600;
            font-size: 20px;
            margin-top: 1px;
            text-align: left;
          ">
          <h4>{{ 'logout' | translate }}</h4>
        </div>

        <li>
          <figure>
            <img [src]="assetsConst.sidebar9" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr" (click)="btn_logOut()">{{
            'logout' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      </ul>
    </p-overlayPanel>
    <p-overlayPanel
      #op2
      class="header_op"
      [style]="{
        width: '200px',
        'overflow-y': 'scroll',
        'scroll-behavior': 'smooth',
      }"
      infiniteScroll
      [infiniteScrollDistance]="20"
      [infiniteScrollThrottle]="20"
      [scrollWindow]="false">
      <div class="profile_drpdwn language_menu_wrapper">
        <div
          class="title"
          style="
            font-weight: 600;
            font-size: 20px;
            margin-top: 1px;
            text-align: center;
          ">
          <h4>{{ 'langugae' | translate }}</h4>
        </div>
        @for (lang of filteredLanguages; track $index) {
          <li>
            <figure>
              <img [src]="assetsConst.sidebar11" alt="svg" />
            </figure>
            <a
              class="dropdown-item hover-hand newClr"
              (click)="setLanguage(lang.language_code)"
              >{{ lang.name }}</a
            >
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
      </div>
    </p-overlayPanel>
    <p-overlayPanel
      #op3
      class="header_op"
      [style]="{
        width: '339px',
        'overflow-y': 'scroll',
        'scroll-behavior': 'smooth',
        left: '1000px !important',
      }"
      infiniteScroll
      [infiniteScrollDistance]="20"
      [infiniteScrollThrottle]="20"
      [scrollWindow]="false">
      <ul class="profile_drpdwn">
        <div
          class="title"
          style="
            font-weight: 600;
            font-size: 20px;
            margin-top: 1px;
            text-align: center;
          ">
          <h4>{{ 'my_account' | translate }}</h4>
        </div>
        <li (click)="gotoAboutUs()">
          <figure>
            <img [src]="assetsConst.Vector1" alt="svg" />
          </figure>
          @if (user() && user().type !== 'DRIVER') {
            <a class="dropdown-item hover-hand newClr fnt">{{
              'aboutUs' | translate
            }}</a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          }
        </li>
        <li (click)="gotoTerms()">
          <figure>
            <img [src]="assetsConst.Vector2" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'termsConditions' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li (click)="gotoPrivacy()">
          <figure>
            <img [src]="assetsConst.Vector3" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'privacyPolicy' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        @if (user() && user().type !== 'DRIVER') {
          <li (click)="gotoContract()">
            <figure>
              <img [src]="assetsConst.Vector4" alt="svg" />
            </figure>
            @if (user() && user().type !== 'DRIVER') {
              <a class="dropdown-item hover-hand newClr fnt">{{
                'legalContract' | translate
              }}</a>
              <div class="arrow">
                <figure>
                  <img [src]="assetsConst.headerArrow" alt="dsfds" />
                </figure>
              </div>
            }
          </li>
          <li (click)="gotoContact()">
            <figure>
              <img [src]="assetsConst.contactCall" alt="svg" />
            </figure>
            <a class="dropdown-item hover-hand newClr fnt">{{
              'contactUs' | translate
            }}</a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
        <li (click)="gotoFaq()">
          <figure>
            <img [src]="assetsConst.Vector1" alt="svg" />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt">{{
            'Faqs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      </ul>
    </p-overlayPanel>
  </ul>
</nav>
